/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import { Link, useLocation } from "react-router-dom";
// import ContactDetail from "./ContactDetail";
// import Practise from "./Practise";

function BlogDetailnew() {
  // const { id } = useParams();
  const { state } = useLocation();
  // const [datas, setadatas] = useState([]);
  const ids = localStorage.getItem("id");
  const agents = localStorage.getItem("agentid");
  // const url = "https://api.dg.dev-iuh.xyz/storage/images/";
  // console.log(datas);
  // const GetDAta = () => {
  //   axios
  //     .get(`https://api.dg.dev-iuh.xyz/api/new_agents/blogs/${id}`)
  //     .then((res) => {
  //       setadatas(res.data?.data);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };
  // useEffect(() => {
  //   GetDAta();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  return (
    <main>
      {/* Start Breadcrumb Area */}
      <section className="page-area area-120">
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12 justify-content-start align-items-center">
              <div className="breadcrumb-title text-center">
                <div className="white-headline">
                  <h2>
                    Blog <span className="sp-color">details</span>
                  </h2>
                </div>
              </div>
              <div className="breadcrumb-page">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb ">
                    <li className="breadcrumb-item">
                      <Link
                        to={`${
                          ids && agents
                            ? `/?websiteid=${ids}&agentid=${agents}`
                            : "/"
                        }`}
                      >
                        Home
                      </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Blog Details
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End Breadcrumb Area */}
      {/*Blog Area Start*/}
      <div className="blog-area blog-details fix area-padding">
        <div className="container">
          <div className="row">
            <div className="col-md-8 col-sm-8 col-xs-12">
              {/* single-blog start */}
              <article className="blog-post-wrapper">
                <div className="blog-banner">
                  <div className="blog-image">
                    <a className="image-scale" href="blog-details.html">
                      <img src={state?.image} alt="" />
                      <div className="blog-item-date">
                        <span className="date-type">
                          {" "}
                          {state?.created_at?.slice(0, 10)}
                        </span>
                        {/* <span className="years-type">Aug, 22</span> */}
                      </div>
                    </a>
                  </div>
                  <div className="blog-content">
                    <div className="blog-meta">
                      <span className="admin-type">
                        <i className="fa fa-user" />
                        {state?.subadmin?.fname + " " + state?.subadmin?.lname}
                      </span>
                      <span className="comments-type">
                        <i className="fa fa-comment-o" />
                        16
                      </span>
                    </div>

                    <div
                      dangerouslySetInnerHTML={{ __html: state?.description }}
                    ></div>
                    <div className="img-blog left-blog-img">
                      <img src="img/blog/b3.jpg" alt="" />
                    </div>
                    <div className="img-blog right-blog-img">
                      <img src="img/blog/b4.jpg" alt="" />
                    </div>
                    {/* <p>
                      But I must explain to you how all this mistaken idea of
                      denouncing pleasure and praising pain was born and I will
                      give you a complete account of the system, and expound the
                      actual teachings of the great explorer of the truth, the
                      master-builder of human happiness. No one rejects,
                      dislikes, or avoids pleasure itself, because it is
                      pleasure, but because those who do not know how to pursue
                      pleasure rationally encounter consequences that are
                      extremely painful.
                    </p> */}
                  </div>
                </div>
              </article>

              {/* single-blog end */}
            </div>
            {/* Start Right Sidebar blog */}
            {/* <ContactDetail /> */}
            {/* <Practise/> */}

            {/* End Right Sidebar */}
          </div>
          {/* End row */}
        </div>
      </div>
      {/*End of Blog Area*/}
      {/* Start Quote Area */}

      {/* End Quote Area */}
    </main>
  );
}

export default BlogDetailnew;
